var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Form',{attrs:{"scheme":_vm.scheme,"method-update-data":_vm.methods.updateData,"method-update-scheme":_vm.methods.updateScheme}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }